import gql from 'graphql-tag'

export const TeamsTreeQuery = gql`
	query teamsTreeQuery {
		teams {
			_id
			n
			path
			a
			maxDevices
			unlimitedDevices
			messagesEnabled {
				value
			}
			nbUsers
			nbDevices
			nbPrograms
			nbMessagePrograms
		}
	}
`

export const TeamsFilterQuery = gql`
	query teamsFilterQuery {
		teams {
			_id
			n
			a
			path
		}
	}
`

export const TeamDetailsQuery = gql`
	query fetchTeamDetails($id: String!) {
		teamById(_id: $id) {
			_id
			n
			a
			path
			children
			maxDevices
			unlimitedDevices
			deviceTtl
			commentCount
			messagesEnabled {
				value
				applyToChildren
				valueForChildren
			}
			parentMessagesEnabled
			thirdPartyDevicesEnabled {
				value
				applyToChildren
				valueForChildren
			}
			parentThirdPartyDevicesEnabled
			playlistSelectionEnabled {
				value
				applyToChildren
				valueForChildren
			}
			parentPlaylistSelectionEnabled
			programEditingEnabled {
				value
				applyToChildren
				valueForChildren
			}
			parentProgramEditingEnabled
			logo
			ipWhitelist
			parentIpWhitelist
			childrenUsers {
				_id
				teamId
			}
			thirdPartyDevices {
				_id
				name
				nickname
				onlineDate
				teamId
			}
			devices {
				_id
				name
				nickname
				OS
				onlineDate
				onlineState
				lastConnection
				contentUpdated
				activationToken
				activationLink
				zones {
					_id
					name
					playState
					program {
						_id
					}
					messagePrograms {
						_id
						updatedBy {
							name
							date
						}
					}
				}
				teamId
			}
			programs {
				_id
				name
				playlists {
					_id
				}
				teamId
				programPlaylistIds
				updatedBy {
					name
					date
				}
			}
			messagePrograms {
				_id
				name
				teamId
				updatedBy {
					name
					date
				}
			}
			users {
				_id
				username
				firstName
				lastName
				teamId
				role
				montyUser
				language
				nicknackSpotifyAppClientId
			}
		}
	}
`
